import { render, staticRenderFns } from "./campaigns-table.vue?vue&type=template&id=5a71264d&"
import script from "./campaigns-table.vue?vue&type=script&lang=js&"
export * from "./campaigns-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports